// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1808":"f39f1b0a","1809":"5f1279c9","2228":"5f1279c9","2700":"5f1279c9","3041":"5f1279c9","5160":"5f1279c9","6508":"71f8506e","8674":"5f1279c9","9267":"98b4201f"}[chunkId] + ".chunk.css";
};